// Function to format time ago
export const timeAgo = (date) => {
  const previousDate = new Date(date);
  const diff = Date.now() - previousDate.getTime();
  if (diff < 0) return "0s";

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours   = Math.floor(minutes / 60);
  const days    = Math.floor(hours / 24);
  const weeks   = Math.floor(days / 7);
  const months  = Math.floor(days / 30.4375);
  const years   = Math.floor(days / 365.25);

  if (seconds < 60) return `${seconds}s`;
  if (minutes < 60) return `${minutes}m`;
  if (hours < 24)   return `${hours}h`;
  if (days < 7)     return `${days}d`;
  if (weeks < 5)    return `${weeks}w`;
  if (months >= 1 && months < 12) return `${months}mon`;
  return `${years}y`;
};



export const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};



